import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import AdminApp from "@/pages/admin/AdminApp";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminApp />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors theme="dark" />
    </div>
  );
}

export default App;
